import type { JSX } from 'react';
import React from 'react';

import { Button, ButtonVariant, Icon, Typography, ConditionView } from '@/shared/ui';

import './SearchFormCard.scss';

interface SearchFormCard<R> {
  title: string;
  content: string | React.ReactNode;
  handleDetails: () => void;
  key: string | number;
}

export const SearchFormCard = <R,>({ title, content, handleDetails }: SearchFormCard<R>): JSX.Element => {
  return (
    <div className="search-form-card">
      <Typography variant="TEXT14" color="graphite">
        {title}
      </Typography>
      <ConditionView if={typeof content === 'string'} else={<>{content}</>}>
        <Typography>{content}</Typography>
      </ConditionView>
      <Button variant={ButtonVariant.ICON_GHOST} onClick={handleDetails}>
        Детальніше <Icon name="arrow_forward" />
      </Button>
    </div>
  );
};
